import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const SALES_ROUTES = new Set([
  'brand.sales',
  'admin.sales',
  'admin.sales.brand',
])

export const checkSalesFeatureFlag: HermesGuardFn = async (to) => {
  if (!SALES_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.salesDashboard')) {
    if (to.name === 'brand.sales') {
      return {
        name: 'brand.home',
        params: { brandId: to.params.brandId },
      }
    }
    return { name: 'brands' }
  }

  return undefined
}
